<template>
    <div class="question-item question-swiper" :class="`question-swiper-${config.layout}`">
        <div
            class="question-content"
            :style="{
                height: topHeight ? `${topHeight + moveNum}px` : null,
                width: leftWidth ? `${leftWidth + moveNum}px` : null,
            }"
        >
            <div class="question-title">
                <TextTemplate class="title" :text="question.title" v-if="question.title" />
                <TextTemplate v-if="question.content" :text="question.content" />
                <AudioPlayer v-if="question.audioUrl" :audioSrc="question.audioUrl" />
                <ImagePreview :picUrl="question.picUrl" v-if="question.picUrl" />
            </div>
        </div>
        <div
            class="question-list"
            :style="{
                height: bottomHeight ? `${bottomHeight - moveNum}px` : null,
                width: rightWidth ? `${rightWidth - moveNum}px` : null,
            }"
        >
            <div
                class="divider"
                @click.stop=""
                @touchstart.stop.prevent="onTouchstart"
                @touchmove.stop.prevent="onTouchmove"
                @touchend.stop.prevent="onTouchend"
            >
                <span />
            </div>
            <div v-if="'LISTENING_BLANK' === question.type" class="listening-blank">
                <Blank
                    :show="true"
                    v-for="item in question.childQuestions"
                    :key="item.id"
                    :question="item"
                    :type="item.type"
                />
            </div>
            <div v-else-if="['LISTENING_MATCH', 'COMPREHENSION_MATCH'].includes(question.type)" class="listening-match">
                <Match :question="question" />
            </div>
            <template v-else>
                <van-tabs
                    class="pagination"
                    :line-width="24"
                    @change="onTabChange"
                    v-model="currentIndex"
                    @touchstart.stop=""
                    @touchmove.stop=""
                >
                    <van-tab
                        v-for="(item, i) in question.childQuestions"
                        :key="item.indexNo"
                        :title="`${item.indexNo}题`"
                        :name="i"
                    />
                </van-tabs>
                <div :class="`swiper swiper-h question-swiper-${question.id}`">
                    <div class="swiper-wrapper">
                        <div v-for="(item, index) in question.childQuestions" class="swiper-slide" :key="item.id">
                            <template v-if="currentIndex - index < 2 && index - currentIndex < 2">
                                <Choice :question="item" v-if="['SINGLE_CHOICE', 'JUDGMENT'].includes(item.type)" />
                                <MuletpleChoice :question="item" v-if="item.type === 'MULTIPLE_CHOICE'" />
                                <Blank
                                    :question="item"
                                    :type="item.type"
                                    v-if="['DISORDER_BLANK', 'ORDER_BLANK'].includes(item.type)"
                                />
                                <Writing :question="item" v-if="item.type === 'WRITING'" />
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import TextTemplate from '../../TextTemplate.vue'
import ImagePreview from '../../ImagePreview.vue'
import AudioPlayer from '../../AudioPlayer.vue'
import Choice from './Choice.vue'
import MuletpleChoice from './MuletpleChoice.vue'
import Blank from './Blank.vue'
import Writing from './Writing.vue'
import Match from './Match.vue'

export default {
    props: ['question'],
    components: { TextTemplate, ImagePreview, AudioPlayer, Choice, MuletpleChoice, Blank, Writing, Match },
    computed: {
        config() {
            return this.$store.state.paperResult.config
        },
        currentQuestion() {
            return this.$store.state.paperResult.currentQuestion
        },
        jumpQuestion() {
            return this.$store.state.paperResult.jumpQuestion
        },
    },
    watch: {
        'config.layout': function () {
            this.updateWidthHeight()
        },
        currentQuestion: function () {
            if (this.currentQuestion && this.currentQuestion.id === this.question.id) {
                this.onSwipeChange()
            }
        },
        jumpQuestion: function () {
            if (this.question.childQuestions && !['LISTENING_BLANK', 'LISTENING_MATCH'].includes(this.question.type)) {
                this.question.childQuestions.forEach((item, i) => {
                    if (item.id === this.jumpQuestion.subQuestionId) {
                        this.questionSwipe.slideTo(i, 1, false)
                    }
                })
            }
        },
    },

    data() {
        return {
            topHeight: 0,
            bottomHeight: 0,
            leftWidth: 0,
            rightWidth: 0,
            moveNum: 0,

            currentIndex: 0,
        }
    },
    created() {
        this.updateWidthHeight()
    },
    mounted() {
        this.questionSwipe = new window.Swiper(`.question-swiper-${this.question.id}`, {
            nested: true,
        })
        this.questionSwipe.on('slideChange', () => {
            this.onSwipeChange()
        })
    },
    methods: {
        onTabChange(i) {
            this.questionSwipe.slideTo(i)
        },
        onSwipeChange() {
            this.currentIndex = this.questionSwipe.activeIndex
            const item = this.question.childQuestions[this.questionSwipe.activeIndex]
            this.$store.dispatch('paperResult/setCurrentSubQuestion', { indexNo: item.indexNo, id: item.id })
        },

        // <<<<<<<<<<<<<<< 拖动
        updateWidthHeight() {
            const defaultNum = 420
            this.topHeight = 0
            this.bottomHeight = 0
            this.leftWidth = 0
            this.rightWidth = 0
            if (this.config.layout === 'mobile') {
                this.topHeight = this.config.clientHeight - this.config.headerHeight - defaultNum
                this.bottomHeight = defaultNum
            } else if (this.config.layout === 'tablet') {
                this.leftWidth = this.config.clientWidth - defaultNum
                this.rightWidth = defaultNum
            }
        },
        onTouchstart(event) {
            if (event.touches.length === 1) {
                this.startX = event.touches[0]['clientX']
                this.startY = event.touches[0]['clientY']
            }
        },
        onTouchmove(event) {
            if (event.touches.length === 1) {
                let num = 0
                if (this.startY && this.config.layout === 'mobile') {
                    num = event.touches[0]['clientY'] - this.startY
                } else if (this.startX && this.config.layout === 'tablet') {
                    num = event.touches[0]['clientX'] - this.startX
                }

                if (this.config.layout === 'mobile') {
                    if (this.topHeight + num >= 80 && this.bottomHeight - num >= 80) {
                        this.moveNum = num
                    }
                } else if (this.config.layout === 'tablet') {
                    if (this.leftWidth + num >= 280 && this.rightWidth - num >= 280) {
                        this.moveNum = num
                    }
                }
            }
        },
        onTouchend() {
            this.startX = 0
            this.startY = 0

            if (this.config.layout === 'mobile') {
                this.topHeight += this.moveNum
                this.bottomHeight -= this.moveNum
            } else if (this.config.layout === 'tablet') {
                this.leftWidth += this.moveNum
                this.rightWidth -= this.moveNum
            }
            this.moveNum = 0
        },
        // 拖动 >>>>>>>>>>>>>>>>>>
    },
}
</script>
<style lang="scss" scoped>
.question-swiper {
    padding: 0;
    overflow: hidden;
    display: flex;
    width: 100%;
    height: 100%;
    .question-title {
        padding: 20px;
        .title {
            font-weight: 700;
            margin-bottom: 12px;
        }
    }
    .pagination {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 32px;
        z-index: 9;
        ::v-deep .van-tabs__wrap {
            height: 32px;
        }
        ::v-deep .van-tabs__line {
            background-color: #ff8c00;
        }
    }
    .swiper {
        width: 100%;
        height: 100%;
        padding-top: 40px;
        box-sizing: border-box;
        .swiper-slide {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            overflow-y: auto;
        }
    }
    .listening-blank {
        height: 100%;
        overflow-y: auto;
        .question-item {
            padding: 8px 18px;
            height: auto;
        }
    }
    .listening-match {
        height: 100%;
    }
}

.question-swiper-mobile {
    flex-direction: column;
    .question-content {
        width: 100%;
        overflow-y: auto;
    }
    .question-list {
        flex-shrink: 0;
        width: 100%;
        box-shadow: 0 0 50px rgba($color: #000000, $alpha: 0.3);
        box-sizing: border-box;
        padding-top: 20px;
        position: relative;
        border-radius: 16px 16px 0 0;
        .divider {
            width: 100%;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            span {
                width: 24px;
                height: 2px;
                background: #ccc;
                border-radius: 4px;
            }
        }
        .pagination {
            top: 32px;
        }
        .swiper {
            padding-top: 40px;
        }
    }
}
.question-swiper-tablet {
    flex-direction: row;
    .question-content {
        height: 100%;
        overflow-y: auto;
    }
    .question-list {
        flex-shrink: 0;
        height: 100%;
        box-shadow: 0 0 50px rgba($color: #000000, $alpha: 0.3);
        position: relative;
        padding-left: 20px;
        position: relative;
        border-radius: 8px 0 0 8px;
        .divider {
            width: 32px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            span {
                width: 2px;
                height: 24px;
                background: #ccc;
                border-radius: 4px;
            }
        }
        .pagination {
            top: 10px;
            padding: 0 20px;
        }
        .swiper {
            padding-top: 30px;
        }
    }
}
</style>
